import { computed } from 'vue';
import { getVm } from '@/helpers/vm-helper';

import type { CountryCode } from '@/helpers/geo-location-helper';
import type { SponsoredRecommendationsInput, SraPlacement } from '@/@types/graphql-types';

import { ObjectType, SraFormat } from '@/@types/graphql-types';
import { Platform } from '@/@types/graphql-types';
import { TrackingAppId } from '@/helpers/tracking/tracking-helper';
import { USER_GEO_LOCATION_COUNTRY_CODE } from '@/helpers/geo-location-helper';
import { WebLocale } from '@/enums/web-locale';

interface UseSponsoredRecOptions {
	pageType: string;
	placement: SraPlacement;

	/** Force SR placements to display a recommendation. */
	testingMode?: boolean;
}

const GEO_COUNTRY_QUERY = 'geoCountrySR' as const;

export const supportedFormats = [SraFormat.Image, SraFormat.Video];
export const supportedObjectTypes = [
	ObjectType.Movie,
	ObjectType.Show,
	ObjectType.GenericTitleList,
	ObjectType.ShowSeason,
];

export function getAllowSponsoredRecommendations({ pageType, placement, testingMode }: UseSponsoredRecOptions) {
	const vm = getVm();
	const geoCountryFromQuery = computed<CountryCode | null>(() => {
		const queryParam = vm.$route.query[GEO_COUNTRY_QUERY] ?? null;
		const geoCountry = (Array.isArray(queryParam) ? queryParam[0] : queryParam) as WebLocale | null;

		return geoCountry ? (geoCountry.toUpperCase() as CountryCode) : null;
	});

	const geoCountry = computed<CountryCode>(() => {
		return geoCountryFromQuery.value && geoCountryFromQuery.value.toLowerCase() in WebLocale
			? (geoCountryFromQuery.value.toLocaleUpperCase() as CountryCode)
			: USER_GEO_LOCATION_COUNTRY_CODE;
	});

	return {
		pageType,
		placement,
		country: vm.$store.getters['language/country'],
		language: vm.$store.getters['language/language'],
		geoCountry: geoCountry.value,

		appId: TrackingAppId,
		platform: Platform.Web,
		// Have every SR Placement supoort every format
		supportedFormats,
		supportedObjectTypes,

		testingMode: testingMode ?? geoCountryFromQuery.value != null,
	} as SponsoredRecommendationsInput;
}
